module.exports = __webpack_public_path__ + "static/media/london-christmas.681f8ac1.jpeg";